/**
 * @generated SignedSource<<98a21852c7c119febdf7374807065ca4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JourneyContextQuery$variables = {};
export type JourneyContextQuery$data = {
  readonly account: {
    readonly allowInviting: boolean | null;
    readonly hrisIntegrated: boolean | null;
    readonly isPersonalType: boolean;
    readonly ssoProvider: string | null;
  };
  readonly user: {
    readonly id: string;
    readonly internalAttributes: {
      readonly manager: {
        readonly id: string;
      } | null;
      readonly primaryConferenceCallProvider: string | null;
    } | null;
  };
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"JourneyContext_viewer">;
  };
};
export type JourneyContextQuery = {
  response: JourneyContextQuery$data;
  variables: JourneyContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryConferenceCallProvider",
  "storageKey": null
},
v2 = [
  (v0/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "manager",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowInviting",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ssoProvider",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hrisIntegrated",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPersonalType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = [
  (v8/*: any*/),
  (v0/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "JourneyContextQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "JourneyContext_viewer"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserInternalAttributes",
            "kind": "LinkedField",
            "name": "internalAttributes",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "JourneyContextQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAccessToCopilot",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "questionAnswers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Invite",
            "kind": "LinkedField",
            "name": "signupConsumedInvite",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "path",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "signupConsumedStreamInviteStream",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "signupMeetingStreams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "nextEventWithContent",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "signupOneononeStreams",
            "plural": true,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "signupPersonalStreams",
            "plural": true,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteTemplateNode",
            "kind": "LinkedField",
            "name": "signupTemplate",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "creator",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isViewer",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "signupTemplateStream",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "signupMeetingRecording",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GoogleUserNode",
                "kind": "LinkedField",
                "name": "google",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserInternalAttributes",
            "kind": "LinkedField",
            "name": "internalAttributes",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "53be632b25085cc8d8bdac56a5fe6eec",
    "id": null,
    "metadata": {},
    "name": "JourneyContextQuery",
    "operationKind": "query",
    "text": "query JourneyContextQuery {\n  viewer {\n    ...JourneyContext_viewer\n    id\n  }\n  user {\n    id\n    internalAttributes {\n      primaryConferenceCallProvider\n      manager {\n        id\n      }\n      id\n    }\n  }\n  account {\n    allowInviting\n    ssoProvider\n    hrisIntegrated\n    isPersonalType\n    id\n  }\n}\n\nfragment JourneyContext_viewer on Viewer {\n  hasAccessToCopilot\n  questionAnswers\n  signupConsumedInvite {\n    id\n    path\n  }\n  signupConsumedStreamInviteStream {\n    url\n    id\n  }\n  signupMeetingStreams {\n    id\n    url\n    createdAt\n    nextEventWithContent {\n      url\n      id\n    }\n  }\n  signupOneononeStreams {\n    url\n    id\n  }\n  signupPersonalStreams {\n    url\n    id\n  }\n  signupTemplate {\n    id\n    url\n    creator {\n      isViewer\n      id\n    }\n  }\n  signupTemplateStream {\n    id\n    url\n  }\n  signupMeetingRecording {\n    id\n  }\n  integrations {\n    google {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "642622755f21f4016ceaf41fc6debd28";

export default node;
